<template>
  <div class="login-window">
    <div
      class="login-left"
      id="login-rongqi"
      style="background: radial-gradient(#eaf0fc 44%, #bab8c7)"
    >
      <img
        src="//t-9.cn/images/logo-b.png"
        alt=""
        height="40"
        class="logo"
        style="z-index: 999"
      />
      <div class="login-back" v-if="!animationPlay" style="width: 100%">
        正在加载中...{{ loadTotleProgress }}%
      </div>
    </div>
    <div class="login-right">
      <div class="login-contanter">
        <div class="login-title">{{ wxlogin ? "微信" : "用户" }}登录</div>

        <div class="login-form" v-if="!wxlogin">
          <div class="login-input">
            <input type="text" v-model="username" placeholder="登录账号 " />
            <span class="iconfont icon-yonghuming"></span>
          </div>
          <div class="login-input">
            <input type="password" v-model="password" placeholder="密码 " />
            <span class="iconfont icon-mima"></span>
          </div>
          <div class="login-remember">
            <input v-model="checked" type="checkbox" /> 记住密码
          </div>
          <div class="login-btn" @click="Login">{{ loginTxt }}</div>
        </div>

        <div class="login-form" v-if="wxlogin && !isWx && isAgree" style="display: none;">
          <div class="login-refresh-main">
            <div class="login-refresh" v-if="wxImg.length < 10">
              <div>正在获取二维码图片</div>
            </div>
            <div class="opticy" v-if="isExpire"></div>

            <div class="login-refresh" v-if="isExpire">
              <div>二维码已失效</div>
              <div @click="wechatScan" class="refreshbtn">刷新</div>
            </div>
            <img style="border: 1px solid #eee; width: 200px" :src="wxImg" />
          </div>
          <p>①微信扫码 ②关注公众号 ③登录成功</p>
        </div>

        <div class="login-wechat" @click="wechatScan" v-if="!wxlogin && !isWx" style="display: none;">
          <span class="iconfont icon-weixin"></span>微信扫码登录
        </div>
        <div class="login-wechat" @click="wechatLogin" v-if="!wxlogin && isWx" style="display: none;">
          <span class="iconfont icon-weixin"></span>微信登录
        </div>
        <div class="login-wechat" @click="wxlogin = false" v-if="wxlogin">
          <span class="iconfont icon-yonghuming" style="color: #ccc"></span
          >账号密码登录
        </div>

        <div class="login-agreement">
          <input type="checkbox" v-model="isAgree" /> 同意
          <a href="/news/1461208860630061056">《用户协议》</a> 与<a
            href="/news/1461207710543515648"
            >《隐私条款》</a
          >
        </div>

        <div class="login-other">
          <div>© 提酒映画 (T-9.CN) 法律声明 隐私协议</div>
          <br />
          <div>
            转载内容版权归作者及来源网站所有，本站原创内容转载请注明来源
          </div>

          <div class="logo-box">
            京ICP备2021036759号-1 京公网安备 11011202003279号
          </div>
        </div>
      </div>
    </div>

    <div class="baoqian">
      <div>
        <span class="iconfont icon-gantanhao" style="font-size: 2rem"></span>
      </div>
      很抱歉，<strong>移动端</strong>暂未开放！<br />请使用<strong>笔记本电脑</strong>访问本系统<br />
      访问地址：<br /><br />
      <div
        style="
          border: 1px #ddd solid;
          width: 80%;
          margin: 0 10%;
          background: #fff;
        "
      >
        <strong>https://t-9.cn</strong>
      </div>
    </div>
    <TDialog
      top="0"
      :visible.sync="visibleSet"
      width="40%"
      title=""
      @close="cancel"
      :isLogin="true"
    >
      <setUserinfo :userinfo="userinfo" :setInfo="setInfo" @cancel="cancel" />
    </TDialog>


    <div class="newtishi">
        <marquee behavior="scroll" direction="left" scrollamount="10" onMouseOut="this.start()" onMouseOver="this.stop()">
            注意：此处无法登录“<span style="color: #39f;">T9数字克隆人系统</span>”，
            需“<a href="https://f1.t-9.cn/t9aihuman/t9aihuman.zip?20230817" style="color: #39f;" target="_blank">下载</a>”
            安装桌面客户端登录
        </marquee>
    </div>
  </div>
</template>

<script>
// import { PixiCommon } from "@/components/other/PixiCommon.js";
import { asyncLoadJs, uuid, isWeiXin, repUrl } from "@/components/util/util_fun.js"
import { javaserver } from "@/components/util/util.js"
import setUserinfo from "../components/setUserinfo.vue"

// import fileUpload from '@/components/ali_oss/alioss.vue'
import { t9oss } from '@/components/util/util.js'
// import wx from 'weixin-js-sdk'
var modelClass
export default {
  data () {
    return {
      userinfo: {},
      setInfo: {
        userPhoto: '',
        userName: '',
      },
      visibleSet: false,
      back: require("@/assets/images/loginback.png"),
      username: "",
      password: "",
      checked: false,
      loginTxt: "立即登录",
      wxlogin: false,
      user: {},
      loadTotleProgress: 0, //模型加载进度
      animationPlay: false, //模型加载是否完成
      wxImg: "",
      expire_seconds: 0, //二维码过期时间
      isExpire: false,
      timer: {},
      expireTime: {},
      isWx: false,
      isAgree: true,
      javaserver: javaserver,
    }
  },
  components: {
    // fileUpload,
    setUserinfo
  },
  created () {
    document.getElementById("home_loading").style.display = "none"
    // document.getElementById("rongqi").style.display = "none";

    this.user = {
      clothesList: ['1465589908042289152'],
      createDate: "2021-12-01",
      isshow: false,
      modelId: "1464164117563707392",
      modelJson: '{"fileDir":"drogue/zip_resource/model_1637918891394/","fileUrl":"https://thvup.oss-cn-beijing.aliyuncs.com/drogue/zip/model_1637918891394.zip?uploadId=F9BCD44335424F29A5D0959724F5C29A","fileType":"zip","fileName":"Qban","timeName":"model_1637918891394.zip","fileList":["Qban_physics.json","Qban_ske.json","Qban_tex.json","Qban_tex.png"]}',
      isHad: true,
      modifyDate: "2021-12-01T03:13:01.413Z",
      param: null,
      parentId: null,
      rolesId: "1464164117635010560",
      rolesLabel: "[\"二次元\",\"qqq\"]",
      rolesName: "wrewq",
      rolesOpen: 0,
      rolesPhoto: "https://thvup.oss-cn-beijing.aliyuncs.com/drogue/zip_resource/model_cover_1638328380763.png",
      rolesSource: 1,
      sex: 0,
      type: 1,
      userId: "1429990189392072704"
    }
    //获取url中问号后的
    if (this.$route.query.call) {
      console.log('query传参需要回跳', this.$route.query)

    } else {
      console.log('正常登录业务')
    }
    if (this.$store.state.isLogin) {
      this.$router.push("/")
    }
  },
  mounted () {
    // document.getElementById("rongqi").style.display = "none";
    this.getCookie()

    if (!this.$store.state.isLogin) {
      //开始初始化模型
      this.init()
      this.isWx = isWeiXin()
      console.log(this.isWx)
    }
  },
  methods: {

    cancel () {
      this.visibleSet = false
      // this.$router.push("/setrole")
      this.$router.push("/home")
      console.log('关闭弹窗')
    },
    async Login () {
      if (this.username.length <= 0) {
        this.$message.warning("请输入账号！")
        return
      }
      if (this.password.length <= 0) {
        this.$message.warning("请输入密码！")
        return
      }

      if (!this.isAgree) {
        this.$message.warning("请勾选同意《用户协议》与《隐私条款》！")
        return
      }

      this.loading = true
      this.loginTxt = "登录中..."
      var that = this

      this.post("/api/auth/login", {
        username: this.username,
        password: this.password,
      })
        .then((res) => {
          that.loading = false
          if (res.status == "200") {

            that.loginTxt = "登录成功"

            // 记住密码
            if (that.checked == true) {
              //传入账号名，密码，和保存天数3个参数
              that.setCookie(that.username, that.password, 1)
            } else {
              console.log("清空Cookie")
              //清空Cookie
              that.clearCookie()
            }

            //设置token
            that.$store.commit(
              "setExp",
              new Date(res.timestamp).getTime() + res.data.time * 1000
            )
            that.$store.commit("setToken", res.data.access_token)
            that.$store.commit("setUser", res.data.user)
            this.userinfo = res.data.user


            if (this.$route.query.call) {
              console.log('跳转到call', this.$route.query.call)
              window.location.href = "https://t-9.cn" + this.$route.query.call
            }



            // that.$router.push("/home");
            // location.href="#/home";
            // location.reload()
            if (res.data.user.userName == '' || res.data.user.userPhoto == '') {
              console.log('跳转到设置角色信息')
              this.setInfo.userName = res.data.user.userName
              this.setInfo.userPhoto = res.data.user.userPhoto
              this.visibleSet = true
            } else {
              that.$router.push("/")

            }


          } else {
            that.loginTxt = res.message
            that.$message.error(res.message)
          }
        })
        .catch(() => {
          that.loading = false
        })
    },

    //微信扫码
    wechatScan () {
      if (!this.isAgree) {
        this.$message.warning("请勾选同意《用户协议》与《隐私条款》！")
        return
      }
      this.wxlogin = true
      this.isExpire = false
      this.getTicket()
    },
    //获取微信二维码
    getTicket () {
      this.loading = true
      var that = this

      this.get("/api/wechat/getQRCode")
        .then((res) => {
          that.loading = false
          clearInterval(this.timer)
          clearInterval(this.expireTime)
          if (res.status == "200") {
            that.wxImg =
              "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=" +
              res.data.data.ticket
            that.expire_seconds = res.data.data.expire_seconds

            that.expireTime = setInterval(() => {
              that.expireEwm()
            }, 1000)
            that.timer = setInterval(() => {
              that.wxScanlogin(res.data.message)
            }, 3000)
          } else {
            // that.$message.error("获取失败！")
          }
        })
        .catch(() => {
          that.loading = false
        })
    },
    // 获取登录信息
    wxScanlogin (code) {
      var that = this
      this.post("/api/wechat/webLogin", { code: code })
        .then((res) => {
          if (res.status == "200") {
            console.log(res.data.user)
            this.userinfo = res.data.user
            // that.$store.commit('setExp', (new Date(res.timestamp).getTime()*1000)+res.data.time);
            that.$store.commit("setToken", res.data.access_token)
            that.$store.commit("setUser", res.data.user)
            that.$store.commit(
              "setExp",
              new Date(res.timestamp).getTime() + res.data.time * 1000
            )
            clearInterval(that.timer)
            clearInterval(that.expireTime)
            if (this.$route.query.call) {
              console.log('跳转到call', this.$route.query.call)
              window.location.href = "https://t-9.cn" + this.$route.query.call
            }



            if (res.data.user.userName == '' || res.data.user.userPhoto == '') {
              console.log('跳转到设置角色信息')
              this.setInfo.userName = res.data.user.userName
              this.setInfo.userPhoto = res.data.user.userPhoto
              this.visibleSet = true
            } else {
              that.$router.push("/")

            }
            // location.reload()
            // location.href="/vup/#/home";
          } else {
            // that.$message.error("获取失败！")
          }
        })
        .catch(() => {
          that.loading = false
        })
    },
    // 二维码过期
    expireEwm () {
      this.expire_seconds--

      if (this.expire_seconds <= 0) {
        this.expire_seconds = 0
        window.clearInterval(this.expireTime)
        window.clearInterval(this.timer)
        this.isExpire = true
      }
    },
    // 获取appid
    wechatLogin () {
      this.post("/api/wechat/getAppId")
        .then((res) => {
          if (res.status == 200) {
            var EncodeUrl = encodeURIComponent(
              "https://t-9.cn/api/wechat/mobileLogin"
            )

            var address =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx007964642b02caf6" +
              "&redirect_uri=" +
              EncodeUrl +
              "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect"

            location.href = address
          } else {
          }
        })
        .catch()
    },
    //初始
    async init () {
      this.dloading = false

      // PixiCommon.initPixi("login-rongqi");

      var that = this
      that.animationPlay = true

      // this.loadStageModel();

      // PixiCommon.tickerAdd();

      window.t9render.modelopen("id", "iframe", "login-rongqi")
      let div = document.getElementById("login-rongqi")
      let s = div.clientWidth / 1180
      setTimeout(() => {
        this.user
        let scene = {
          res: [
            {
              resid: this.user.rolesId,
              resname: '',
              resobj: this.user,
              restype: 1,
              scale: { x: s, y: s },
              position: { x: div.clientWidth / 2, y: div.clientHeight + 60 }
            }
          ],
          scene: {}
        }
        //  console.log("aaa",scene);
        window.t9render.setScene(scene, "iframe")
      }, 1000)

    },



    // 获取动作列表，播放默认动画
    getAction () {
      var playKey = ""
      if (
        modelClass.dbmodels.model.armature.armatureData.defaultActions.length >
        0
      ) {
        playKey =
          modelClass.dbmodels.model.armature.armatureData.defaultActions[0]
            .name
      } else {
        action.animationNames.forEach((key) => {
          animationList.push(key)
          if (key.indexOf("idle") != -1) {
            playKey = key
          }
        })
      }
      if (playKey == "") {
        playKey = animationList[0]
      }
      modelClass.playAnimation(playKey, 0)
    },

    //设置cookie
    setCookie (c_name, c_pwd, exdays) {
      var exdate = new Date() //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString()
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString()
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ") //这里显示的格式需要切割一下自己可输出看下

        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=") //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.username = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.password = arr2[1]
            this.checked = true
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1) //修改2值都为空，天数为负1天就好了
    },
  },
  beforeDestroy () {
    // PixiCommon.animationfunlist_del("animationPlay");
    // PixiCommon.removeAppStageObjectByName("zhujue");
    // PixiCommon.clearBack();
    // modelClass.destroy();
  },
};
</script>
<style lang="scss" scoped>
.login-agreement {
  a {
    color: #39f;
  }
}
.baoqian {
  display: none;
}
.newtishi{
    width: 80%;
    color: #f06f6d;
    background-color: #fdf0f0;
    padding: 10px;
    position: absolute;
    top: 1%;
    left: 10%;
    border-radius:5px ;
    font-size: 16px;
}
@media screen and (max-width: 600px) {
  .login-right {
    display: none;
  }
  .baoqian {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: aliceblue;
    left: 0;
    top: 0;
    z-index: 999;
    padding: 200px 0;
    display: block;
    line-height: 2em;
    font-size: 0.5rem;
  }
}
</style>
